import { supabase } from "@/integrations/supabase/client";

const STORAGE_KEY = "xeno.session.id";

export function getLocalSessionId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function setLocalSessionId(id: string) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
}

export function clearLocalSessionId() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

function generateSessionId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `xeno-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

/**
 * Claim this device as the account's active session.
 *
 * Failure-safe: the new id is written to localStorage ONLY after the RPC
 * succeeds. If the RPC fails (network, timeout), localStorage is untouched —
 * so a freshly signed-in user cannot lock themselves out with an id that the
 * server never received.
 */
export async function claimActiveSession(): Promise<string | null> {
  if (typeof window === "undefined") return null;
  const newId = generateSessionId();
  const { error } = await supabase.rpc("claim_active_session", { _session_id: newId });
  if (error) {
    console.warn("[active-session] claim failed", error.message);
    return null;
  }
  setLocalSessionId(newId);
  return newId;
}
